const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 1050, // bumped from 960 to improve homepage card layout on mid-range tablets
    lg: 1280,
    xl: 1440,
  },
};

export default breakpoints;
